import React from 'react';
import { BrainIcon, BatteryWarningIcon, RepeatIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-white" data-id="element-226">
      <div className="container mx-auto px-4" data-id="element-227">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-228">
          <h2 className="text-3xl lg:text-4xl font-serif font-bold text-gray-900 mb-6" data-id="element-229">
            Llegás a casa. Tenés hambre. Abrís la heladera… <br data-id="element-230" />
            <span className="text-rose-500" data-id="element-231">y tu mente se apaga.</span>
          </h2>
          <p className="text-xl text-gray-600 italic" data-id="element-232">"Otra vez lo mismo."</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-233">
          <div className="bg-orange-50 p-8 rounded-2xl border border-orange-100 hover:shadow-lg transition-shadow" data-id="element-234">
            <div className="bg-white w-14 h-14 rounded-full flex items-center justify-center mb-6 shadow-sm text-rose-500" data-id="element-235">
              <BatteryWarningIcon className="w-8 h-8" data-id="element-236" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-237">
              No es pereza. Es saturación.
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-238">
              Después de tomar 100 decisiones en el trabajo y con los chicos, tu
              cerebro simplemente se apaga. No tenés energía para ser creativa a
              las 8pm.
            </p>
          </div>

          <div className="bg-orange-50 p-8 rounded-2xl border border-orange-100 hover:shadow-lg transition-shadow transform md:-translate-y-4" data-id="element-239">
            <div className="bg-white w-14 h-14 rounded-full flex items-center justify-center mb-6 shadow-sm text-rose-500" data-id="element-240">
              <BrainIcon className="w-8 h-8" data-id="element-241" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-242">
              La carga invisible
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-243">
              Llevás la carga mental de toda la casa. Qué falta comprar, qué
              comen los chicos, qué se descongela. Nadie lo ve, pero vos lo
              sentís todo el día.
            </p>
          </div>

          <div className="bg-orange-50 p-8 rounded-2xl border border-orange-100 hover:shadow-lg transition-shadow" data-id="element-244">
            <div className="bg-white w-14 h-14 rounded-full flex items-center justify-center mb-6 shadow-sm text-rose-500" data-id="element-245">
              <RepeatIcon className="w-8 h-8" data-id="element-246" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-247">
              El ciclo que se repite
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-248">
              Delivery caro, culpa por comer mal, promesa de que "mañana
              cocino". Pero mañana llega el cansancio de nuevo. No es tu culpa,
              es el sistema.
            </p>
          </div>
        </div>

        <div className="mt-16 text-center" data-id="element-249">
          <p className="text-2xl font-serif text-gray-800 font-medium" data-id="element-250">
            Pero ahora...{' '}
            <span className="text-rose-500 font-bold" data-id="element-251">algo cambia.</span>
          </p>
        </div>
      </div>
    </section>;
}